import React from 'react';
import Layout from '@common/layout';
import Head from 'next/head';
import TheTeam from '../components/the-team/the-team';

const TheTeamPage = () => (
    <React.Fragment>
        <Head>
            <title>Realm | Our Projects</title>
        </Head>
        <div className=" bg-realm-dark pt-32 md:pt-40 min-h-screen">
            <TheTeam />
        </div>
    </React.Fragment>
);

export default Layout(TheTeamPage, {
    headerMode: 'fixed',
    headerOptions: {
        menuColor: 'text-white lg:text-white',
        borderColor: 'lg:border-white',
        hoverBorderColor: 'lg:hover:border-white',
    },
    footerColor: 'bg-tan',
});
